export default __webpack_public_path__ + "static/media/pool-res5.1de5c4b4.jpg";